export const SidebarNavItemVariants = Object.freeze({
    Group: 'group',
    Link: 'link',
    Disabled: 'disabled'
});

export type SidebarNavItemVariant = (typeof SidebarNavItemVariants)[keyof typeof SidebarNavItemVariants];
